/**
 * WordPress dependencies
 */
import {
	addFilter,
	applyFilters
} from '@wordpress/hooks'
import {
	PanelBody,
	ToggleControl,
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import { RichText } from '@wordpress/block-editor'

/**
 * External dependencies
 */
import {
	AdvancedRangeControl,
} from '~cartzillagb/components'
import {
	withTabbedInspector,
	withUniqueClass,
	withBlockStyles,
} from '~cartzillagb/higher-order'
import { range } from '~cartzillagb/util'
import { i18n } from 'cartzillagb'
import classnames from 'classnames'

/**
 * Internal dependencies
 */
import { name } from './index'
import createStyles from './style'

addFilter( 'cartzillagb.accordion.edit.inspector.style.before', 'czgb/accordion', ( output, props ) => {
	const { 
		attributes,
		setAttributes 
	} = props

	const {
		limit,
		enableContainer
	} = attributes

	return (
		<PanelBody
			label={ __( 'General', i18n ) }
			initialOpen={ true }
		>
			<AdvancedRangeControl
				label={ __( 'Limit', i18n ) }
				value={ limit }
				onChange={ limit => setAttributes( { limit } ) }
				min={ 1 }
				max={ applyFilters( 'cartzillagb.accordion.max.limit', 12 ) }
				allowReset={ false }
			/>
			<ToggleControl
				label={ __( 'Enable Container ?', i18n ) }
				checked={ enableContainer }
				onChange={ enableContainer => setAttributes( { enableContainer } ) }
			/>
		</PanelBody>
	)
} )

const edit = props => {
	const {
		blockName,
		styles,
		className,
		attributes,
		setAttributes,
	} = props

	const {
		enableContainer,
		limit,
		uniqueClass,
	} = attributes

	const spacingClasses = applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.spacingclass.attributes`, {}, props )

	const mainClasses = classnames( [
		uniqueClass,
		className,
		spacingClasses
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	return (
		<div className={ mainClasses }>
			{ styles }
			<div className={ enableContainer ? 'container' : '' }>
				{ applyFilters( `cartzillagb.${ blockName }.edit.output.block-title`, null, null, props ) }
				<div id={ `${ uniqueClass }-Accordion` } className="accordion">
					{ range( 1, limit + 1 ).map( i => {

						let defaultAccordionTitle = ''
						const defaultAccordionDesc = __( "<p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.</p><p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore.</p>", i18n )

						switch ( i % 3 ) {
							case 1:
								defaultAccordionTitle = __( 'Credit / debit cards', i18n )
							break

							case 2:
								defaultAccordionTitle = __( 'Pay with PayPal', i18n )
							break

							case 0:
								defaultAccordionTitle = __( 'Redeem reward points', i18n )
							break
						}

						return (
							<div className="card" key={ i }>
								<div className="card-header" id={ `${ uniqueClass }${ i }-HeadingOne` }>
									<h3 className="accordion-heading">
										<a href={ `#${ uniqueClass }${ i }-Collapse` } className={  i === 1 ? '' : 'collapsed' } role="button" data-toggle="collapse" aria-expanded={ i === 1 ? 'true' : 'false' } aria-controls={ `${ uniqueClass }${ i }-Collapse` }>
											<RichText
												tagName="span"
												value={ attributes[ `accordionTitle${ i }` ] || defaultAccordionTitle }
												onChange={ value => setAttributes( { [ `accordionTitle${ i }` ]: value } ) }
												placeholder={ __( 'Accordion Title', i18n ) }
											/>
											<span className="accordion-indicator">
												<i data-feather="chevron-up"></i>
											</span>
										</a>
									</h3>
								</div>
								<div id={ `${ uniqueClass }${ i }-Collapse` } className={ `collapse${ i === 1 ? ' show' : '' }` } data-parent={ `#${ uniqueClass }-Accordion` }>
									<RichText
										tagName="div"
										className={ 'card-body font-size-md' }
										multiline={ true }
										value={ attributes[ `accordionDesc${ i }` ] || defaultAccordionDesc }
										onChange={ value => setAttributes( { [ `accordionDesc${ i }` ]: value } ) }
										placeholder={ __( 'Accordion Description', i18n ) }
									/>
								</div>
							</div>
						)
					} ) }
				</div>
			</div>
		</div>
	)
}

export default compose(
	withUniqueClass,
	withBlockStyles( createStyles, { editorMode: true } ),
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )